import styled from 'styled-components';
import {Space} from 'antd';
import Spin from '../../components/Spin';

const StyledOverviewUserPageContent = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    width: 100%;
  }
`;

const StyledOverviewUserPageSpin = styled(Spin)`
  min-height: calc(100vh - 66px);
  max-height: unset !important;
`;

const StyledOverviewUserPageHeaderSpace = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    background-color: ${props => props.theme.colors.neutral_1};
    border: 1px solid ${props => props.theme.colors.neutral_4};
    border-radius: 4px;
    padding: 16px 24px;
    width: 100%;

    h5 {
      color: ${props => props.theme.colors.neutral_7};
      margin: 0;
    }
  }

  &.single-item {
    & > .ant-space-item {
      width: 100%;
      max-width: unset;
    }
  }

  /* Make all .ant-space-item have the same height as the tallest */
  & {
    align-items: stretch;
  }
`;

export {
  StyledOverviewUserPageContent,
  StyledOverviewUserPageSpin,
  StyledOverviewUserPageHeaderSpace
}
